import styled from "vue-styled-components";

export const CHeaderTop = styled.div`
    font-size: 1.1rem;
    line-height: 1.5;
    letter-spacing: .025rem;
    color: ${props => props.theme?.header_top?.color ?? '#000'};
    background-color: ${props => props.theme?.header_top?.background_color ?? '#fff'};
    border-bottom: 2px solid ${props => props.theme?.header_top?.border_color ?? '#fff'};
    padding-top: .4rem;
    padding-bottom: .4rem;
    display: ${props => props.theme?.header_top?.active ? 'block' : 'none'};

    @media (max-width: 969px) {
        display: block;
    }
`;

export const CMenuFloat = styled.div`
    border-radius: 0.3rem;
    margin: 2rem 0;

    h2 {
        padding: 1.3rem 2rem;
        background: ${props => props.theme?.header?.menu?.categories?.background_color ?? props.theme?.header?.menu?.background_color ?? props.theme.primary_color};
        color: ${props => props.theme?.header?.menu?.categories?.color ?? props.theme?.header?.menu?.color ?? '#fff'};
        margin-bottom: 0;
        font-weight: ${props => props.theme?.header?.menu?.font_weight ?? 700};
        text-transform: ${props => props.theme?.header?.menu?.text_transform ?? 'capitalize'};
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
        border: 1px solid ${props => props.theme?.header?.menu?.categories?.background_color ?? props.theme?.header?.menu?.background_color ?? props.theme.primary_color};
        display: flex;
        align-items: center;
        line-height: normal;
        i {
            margin-right: 1.3rem;
        }
    }

    ul {
        margin-bottom: 0;
    }

    > ul {
        > li {
            border: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
            border-bottom: none;
            > a {
                padding: 1rem 5rem 1rem 2rem;
            }

            &.active {
                > a span {
                    transform: rotate(-180deg);
                    border-right: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                    border-left: none;
                }
                > ul {
                    display: block;
                    opacity: 1;
                    pointer-events: auto;
                    > li {
                        border-top: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                        &.active {
                            > a span {
                                transform: rotate(-180deg);
                                border-right: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                                border-left: none;
                            }
                            > ul {
                                display: block;
                                opacity: 1;
                                pointer-events: auto;
                                > li {
                                    border-top: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                                    &.active {
                                        > a span {
                                            transform: rotate(-180deg);
                                            border-right: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                                            border-left: none;
                                        }
                                        > ul {
                                            display: block;
                                            opacity: 1;
                                            pointer-events: auto;
                                            > li {
                                                border-top: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            > ul {
                display: none;
                transition: all .3s ease;
                pointer-events: none;
                opacity: 0;
                > li {
                    > a {
                        padding: 1rem 5rem 1rem 3rem;
                    }
                    > ul {
                        display: none;
                        > li {
                            > a {
                                padding: 1rem 5rem 1rem 4rem;
                            }
                            > ul {
                                display: none;
                                > li {
                                    > a {
                                        padding: 1rem 1rem 1rem 5rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    li {
        position: relative;

        &:last-child {
            border-bottom: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
        }
        a {
            text-decoration: none;
            height: 100%;
            width: 100%;
            display: flex;
            position: relative
            letter-spacing: 0.2px;
            font-weight: ${props => props.theme?.header?.menu?.font_weight ?? 700};
            text-transform: ${props => props.theme?.header?.menu?.text_transform ?? 'capitalize'};
            font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
            font-family: ${props => props.theme?.header?.menu?.font_family ?? 'Poppins'};
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            > span {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                padding: 1rem 2rem;
                display: flex;
                align-items: center;
                transform: rotate(0deg);
                border-left: 1px solid ${props => props.theme?.border_color_site ?? '#f0f0f0'};
                &:after {
                    line-height: normal;
                    font-family: 'Porto';
                    font-size: 9px;
                    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                    content: '\\e82a';
                }
            }
        }
    }
`

export const CPageShortcut = styled.div`
    > ul {
        display: flex;
        align-items: center;
        margin: ${props => props.theme?.page_shortcut?.margin ?? '0'};
        > li {
            padding: ${props => props.theme?.page_shortcut?.padding ?? '0 0 0 15px'};
            position: relative;
            &:after {
                content: "${props => props.theme?.page_shortcut?.content_separator?.content ?? ''}";
                color: ${props => props.theme?.page_shortcut?.content_separator?.color ?? '#fff'};
                font-weight: 200;
                position: absolute;
                top: 50%;
                right: -12px;
                font-size: 14px;
                margin-top: -9.55px;
            }
            &:last-child::after {
                display: none;
            }
            > a {
                text-decoration: none;
                color: ${props => props.theme?.page_shortcut?.color ?? '#000'};
                font-size: ${props => props.theme?.page_shortcut?.font_size ?? '1.1rem'};
                letter-spacing: 0.025rem;
                font-family: ${props => props.theme?.page_shortcut?.font_family ?? 'Open Sans'}, sans-serif;
                text-transform: ${props => props.theme?.page_shortcut?.text_transform ?? 'initial'};
                font-weight: ${props => props.theme?.page_shortcut?.font_weight ?? '400'};
                > span {
                    position: relative;
                    margin-right: 5px;
                    &:after {
                        position: absolute;
                        top: 50%;
                        left: 3px;
                        display: inline-block;
                        transform: translateY(-50%);
                        line-height: 1;
                        font-family: 'Porto';
                        font-size: 9px;
                        color: ${props => props.theme?.page_shortcut?.color ?? '#000'};
                        content: '\\e82a';
                    }
                }
                &:hover,
                &:focus {
                    > span::after {
                        color: ${props => props.theme?.page_shortcut?.color_hover ?? '#000'};
                    }
                    color: ${props => props.theme?.page_shortcut?.color_hover ?? '#000'};
                }
            }
        }
    }

    @media (max-width: 969px) {
        > ul {
            display: none;
        }
    }
`;

export const CMenuShortcut = styled.ul`
    display: flex;
    align-items: end; // center
    margin: ${props => props.theme?.menu_shortcut?.margin ?? '0'};
    > li {
        padding: ${props => props.theme?.menu_shortcut?.title?.padding ?? '0 0 0 20px'};
        position: relative;
        &.menu-shortcut-categories {
            margin-bottom: -1px;
        }
        &.pages-menu {
            a {
                display: flex;
                align-items: flex-end; // center
                i {
                    margin: ${props => props.theme?.menu_shortcut?.icons?.margin ?? '0 0.3rem 0 0'};
                    font-size: ${props => props.theme?.menu_shortcut?.icons?.font_size ?? props.theme?.menu_shortcut?.title?.font_size ?? '1.5rem'};
                }
                .label-page {
                    font-weight: ${props => props.theme?.menu_shortcut?.label_page?.font_weight ?? '600'};
                    font-size: ${props => props.theme?.menu_shortcut?.label_page?.font_size ?? '1rem'};
                    line-height: normal;
                    color: ${props => props.theme?.menu_shortcut?.label_page?.color ?? '#777777'};
                    margin: ${props => props.theme?.menu_shortcut?.label_page?.margin ?? '0'};
                    text-transform: ${props => props.theme?.menu_shortcut?.label_page?.text_transform ?? 'uppercase'};
                    font-family: ${props => props.theme?.menu_shortcut?.label_page?.font_family ?? 'Poppins'}, sans-serif;
                    letter-spacing: normal;
                }
            }
        }
        > a {
            text-decoration: none;
            color: ${props => props.theme?.menu_shortcut?.title?.color ?? '#484848'};
            font-size: ${props => props.theme?.menu_shortcut?.title?.font_size ?? '1.5rem'};
            line-height: normal;
            letter-spacing: 0.025rem;
            white-space: nowrap;
            font-family: ${props => props.theme?.menu_shortcut?.title?.font_family ?? 'Oswald'}, sans-serif;
            text-transform: ${props => props.theme?.menu_shortcut?.title?.text_transform ?? 'uppercase'};
            font-weight: ${props => props.theme?.menu_shortcut?.title?.font_weight ?? '400'};
            &::first-letter {
                text-transform: uppercase;
            }
            > span {
                position: relative;
                margin-right: 5px;
                &:after {
                    position: absolute;
                    top: 50%;
                    left: 3px;
                    display: inline-block;
                    transform: translateY(-50%);
                    line-height: 1;
                    font-family: 'Porto';
                    font-size: 9px;
                    color: ${props => props.theme?.menu_shortcut?.title?.color ?? '#000'};
                    content: '\\e82a';
                }
            }
            &:hover,
            &:focus {
                > span::after {
                    color: ${props => props.theme?.menu_shortcut?.title?.color_hover ?? '#000'};
                }
                color: ${props => props.theme?.menu_shortcut?.title?.color_hover ?? '#000'};
            }
        }
        > div {
            display: none;
            position: absolute;
            width: ${props => props.theme?.menu_shortcut?.width ?? '200px'};
            z-index: 99;
            transition: all .25s;
            > ul {
                display:flex;
                background: ${props => props.theme?.menu_shortcut?.div_background_color ?? '#fff'};
                flex-direction:column;
                list-style:none;
                width:100%;
                height:auto;
                position: absolute;
                margin-top: 0;
                cursor: pointer;
                border: 1px solid ${props => props.theme?.menu_shortcut?.div_border_color ?? 'transparent'};
                padding: 1.5px 3px;
                box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
                > li {
                    background-color: ${props => props.theme?.menu_shortcut?.background_color ?? '#fff'};
                    margin: 1.5px 0;
                    cursor: pointer;
                    border-radius: ${props => props.theme?.menu_shortcut?.item_menu_border_radius ?? '0'};
                    transition: all .3s linear;
                    position: relative;
                    > a {
                        width: 100%;
                        height: 100%;
                        padding: ${props => props.theme?.menu_shortcut?.padding ?? '0.7rem 1.2rem'};
                        position: relative;
                        display: inline-block;
                        letter-spacing: 0.15px;
                        text-transform: ${props => props.theme?.menu_shortcut?.text_transform ?? 'uppercase'};
                        font-size: ${props => props.theme?.menu_shortcut?.font_size ?? '1.2rem'};
                        font-weight: ${props => props.theme?.menu_shortcut?.font_weight ?? '400'};
                        font-family: ${props => props.theme?.menu_shortcut?.font_family ?? 'Poppins'};
                        color: ${props => props.theme?.menu_shortcut?.color ?? '#484848'};
                        &::first-letter {
                            text-transform: uppercase;
                        }
                        > span {
                            width: 100%;
                            display: inline-block;
                            position: absolute;
                            top: 50%;
                            ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0.4rem;' : 'right: 1.2rem;'}
                            &:after {
                                position: absolute;
                                top: 50%;
                                ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0%;' : 'right: 0%;'}
                                display: inline-block;
                                transform: translateY(-50%) ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'rotate(90deg)' : 'rotate(-90deg)'};
                                line-height: 1;
                                font-family: 'Porto';
                                font-size: 8px;
                                color: ${props => props.theme?.menu_shortcut?.color ?? '#000'};
                                content: '\\e82a';
                            }
                        }
                        &:hover,
                        &:focus {
                            > span::after {
                                color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                            }
                            text-decoration: none;
                            color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                        }
                    }
                    &:hover {
                        background-color: ${props => props.theme?.menu_shortcut?.background_color_hover ?? '#f4f4f4'};
                        > a {
                            color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                            > span::after {
                                color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                            }
                        }
                    }
                    > .menu-shortcut-simple {
                        display: none;
                        position: absolute;
                        left: ${props => props.theme?.menu_shortcut?.open_side_categories ?? '100%'};
                        top: 0px;
                        width: ${props => props.theme?.menu_shortcut?.width ?? '200px'};
                        z-index: 99;
                        transition: all .25s;
                        > ul {
                            display:flex;
                            background: ${props => props.theme?.menu_shortcut?.div_background_color ?? '#fff'};
                            flex-direction:column;
                            list-style:none;
                            width:100%;
                            height:auto;
                            position: absolute;
                            margin-top: 0;
                            cursor: pointer;
                            border: 1px solid ${props => props.theme?.menu_shortcut?.div_border_color ?? 'transparent'};
                            padding: 1.5px 3px;
                            box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
                            > li {
                                background-color: ${props => props.theme?.menu_shortcut?.background_color ?? '#fff'};
                                margin: 1.5px 0;
                                cursor: pointer;
                                transition: all .3s linear;
                                position: relative;
                                > a {
                                    width: 100%;
                                    height: 100%;
                                    padding: ${props => props.theme?.menu_shortcut?.padding ?? '0.7rem 1.2rem'};
                                    position: relative;
                                    display: inline-block;
                                    letter-spacing: 0.05px;
                                    text-transform: ${props => props.theme?.menu_shortcut?.text_transform ?? 'uppercase'};
                                    font-size: ${props => props.theme?.menu_shortcut?.font_size ?? '1.2rem'};
                                    font-weight: ${props => props.theme?.menu_shortcut?.font_weight ?? '400'};
                                    font-family: ${props => props.theme?.menu_shortcut?.font_family ?? 'Poppins'};
                                    color: ${props => props.theme?.menu_shortcut?.color ?? '#484848'};
                                    &::first-letter {
                                        text-transform: uppercase;
                                    }
                                    > span {
                                        width: 100%;
                                        display: inline-block;
                                        position: absolute;
                                        top: 50%;
                                        ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0.4rem;' : 'right: 1.2rem;'}
                                        &:after {
                                            position: absolute;
                                            top: 50%;
                                            ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0%;' : 'right: 0%;'}
                                            display: inline-block;
                                            transform: translateY(-50%) ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'rotate(90deg)' : 'rotate(-90deg)'};
                                            line-height: 1;
                                            font-family: 'Porto';
                                            font-size: 8px;
                                            color: ${props => props.theme?.menu_shortcut?.color ?? '#000'};
                                            content: '\\e82a';
                                        }
                                    }
                                    &:hover,
                                    &:focus {
                                        > span::after {
                                            color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                        }
                                        text-decoration: none;
                                        color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                    }
                                }
                                &:hover {
                                    background-color: ${props => props.theme?.menu_shortcut?.background_color_hover ?? '#f4f4f4'};
                                    > a {
                                        color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                        > span::after {
                                            color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                        }
                                    }
                                }
                                > div {
                                    display: none;
                                    position: absolute;
                                    left: ${props => props.theme?.menu_shortcut?.open_side_categories ?? '100%'};
                                    top: 0px;
                                    width: ${props => props.theme?.menu_shortcut?.width ?? '200px'};
                                    z-index: 99;
                                    transition: all .25s;
                                    > ul {
                                        display:flex;
                                        background: ${props => props.theme?.menu_shortcut?.div_background_color ?? '#fff'};
                                        flex-direction:column;
                                        list-style:none;
                                        width:100%;
                                        height:auto;
                                        position: absolute;
                                        margin-top: 0;
                                        cursor: pointer;
                                        padding: 1.5px 3px;
                                        border: 1px solid ${props => props.theme?.menu_shortcut?.div_border_color ?? 'transparent'};
                                        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
                                        > li {
                                            background-color: ${props => props.theme?.menu_shortcut?.background_color ?? '#fff'};
                                            margin: 1.5px 0;
                                            cursor: pointer;
                                            transition: all .3s linear;
                                            position: relative;
                                            > a {
                                                width: 100%;
                                                height: 100%;
                                                padding: ${props => props.theme?.menu_shortcut?.padding ?? '0.7rem 1.2rem'};
                                                position: relative;
                                                display: inline-block;
                                                letter-spacing: 0.05px;
                                                text-transform: ${props => props.theme?.menu_shortcut?.text_transform ?? 'uppercase'};
                                                font-size: ${props => props.theme?.menu_shortcut?.font_size ?? '1.2rem'};
                                                font-weight: ${props => props.theme?.menu_shortcut?.font_weight ?? '400'};
                                                font-family: ${props => props.theme?.menu_shortcut?.font_family ?? 'Poppins'};
                                                color: ${props => props.theme?.menu_shortcut?.color ?? '#484848'};
                                                &::first-letter {
                                                    text-transform: uppercase;
                                                }
                                                > span {
                                                    width: 100%;
                                                    display: inline-block;
                                                    position: absolute;
                                                    top: 50%;
                                                    ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0.4rem;' : 'right: 1.2rem;'}
                                                    &:after {
                                                        position: absolute;
                                                        top: 50%;
                                                        ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0%;' : 'right: 0%;'}
                                                        display: inline-block;
                                                        transform: translateY(-50%) ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'rotate(90deg)' : 'rotate(-90deg)'};
                                                        line-height: 1;
                                                        font-family: 'Porto';
                                                        font-size: 8px;
                                                        color: ${props => props.theme?.menu_shortcut?.color ?? '#000'};
                                                        content: '\\e82a';
                                                    }
                                                }
                                                &:hover,
                                                &:focus {
                                                    > span::after {
                                                        color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                    }
                                                    text-decoration: none;
                                                    color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                }
                                            }
                                            &:hover {
                                                background-color: ${props => props.theme?.menu_shortcut?.background_color_hover ?? '#f4f4f4'};
                                                > a {
                                                    color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                    > span::after {
                                                        color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                    }
                                                }
                                            }
                                            > div {
                                                display: none;
                                                position: absolute;
                                                left: ${props => props.theme?.menu_shortcut?.open_side_categories ?? '100%'};
                                                top: 0px;
                                                width: ${props => props.theme?.menu_shortcut?.width ?? '200px'};
                                                z-index: 99;
                                                transition: all .25s;
                                                > ul {
                                                    display:flex;
                                                    background: ${props => props.theme?.menu_shortcut?.div_background_color ?? '#fff'};
                                                    flex-direction:column;
                                                    list-style:none;
                                                    width:100%;
                                                    height:auto;
                                                    position: absolute;
                                                    margin-top: 0;
                                                    cursor: pointer;
                                                    padding: 1.5px 3px;
                                                    border: 1px solid ${props => props.theme?.menu_shortcut?.div_border_color ?? 'transparent'};
                                                    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
                                                    > li {
                                                        background-color: ${props => props.theme?.menu_shortcut?.background_color ?? '#fff'};
                                                        margin: 1.5px 0;
                                                        cursor: pointer;
                                                        transition: all .3s linear;
                                                        position: relative;
                                                        > a {
                                                            width: 100%;
                                                            height: 100%;
                                                            padding: ${props => props.theme?.menu_shortcut?.padding ?? '0.7rem 1.2rem'};
                                                            position: relative;
                                                            display: inline-block;
                                                            letter-spacing: 0.05px;
                                                            text-transform: ${props => props.theme?.menu_shortcut?.text_transform ?? 'uppercase'};
                                                            font-size: ${props => props.theme?.menu_shortcut?.font_size ?? '1.2rem'};
                                                            font-weight: ${props => props.theme?.menu_shortcut?.font_weight ?? '400'};
                                                            font-family: ${props => props.theme?.menu_shortcut?.font_family ?? 'Poppins'};
                                                            color: ${props => props.theme?.menu_shortcut?.color ?? '#484848'};
                                                            &::first-letter {
                                                                text-transform: uppercase;
                                                            }
                                                            > span {
                                                                width: 100%;
                                                                display: inline-block;
                                                                position: absolute;
                                                                top: 50%;
                                                                ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0.4rem;' : 'right: 1.2rem;'}
                                                                &:after {
                                                                    position: absolute;
                                                                    top: 50%;
                                                                    ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'left: 0%;' : 'right: 0%;'}
                                                                    display: inline-block;
                                                                    transform: translateY(-50%) ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'rotate(90deg)' : 'rotate(-90deg)'};
                                                                    line-height: 1;
                                                                    font-family: 'Porto';
                                                                    font-size: 8px;
                                                                    color: ${props => props.theme?.menu_shortcut?.color ?? '#000'};
                                                                    content: '\\e82a';
                                                                }
                                                            }
                                                            &:hover,
                                                            &:focus {
                                                                > span::after {
                                                                    color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                                }
                                                                text-decoration: none;
                                                                color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                            }
                                                        }
                                                        &:hover {
                                                            background-color: ${props => props.theme?.menu_shortcut?.background_color_hover ?? '#f4f4f4'};
                                                            > a {
                                                                color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                                > span::after {
                                                                    color: ${props => props.theme?.menu_shortcut?.color_hover ?? '#484848'};
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            &:hover > div  {
                                                display:block;
                                                margin-top: -3px;
                                                position: absolute;
                                                ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'right: 100%;' : 'left: 100%;'}
                                            }
                                        }
                                    }
                                }
                                &:hover > div  {
                                    display:block;
                                    margin-top: -3px;
                                    position: absolute;
                                    ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'right: 100%;' : 'left: 100%;'}
                                }
                            }
                        }
                    }
                    &:hover > .menu-shortcut-simple  {
                        display:block;
                        margin-top: -3px;
                        position: absolute;
                        ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'right: 100%;' : 'left: 100%;'}
                    }
                    > .menu-shortcut-advanced {
                        display: none;
                        position: absolute;
                        width: ${props => props.theme?.menu_advanced?.width ?? '600px'};
                        z-index: 99;
                        transition: all .25s;
                        top: -3px;
                        left: ${props => props.theme?.menu_shortcut?.open_side_categories ?? '100%'};
                        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
                        background-color: ${props => props.theme?.menu_advanced?.background_color ?? '#fff'};
                        border: 1px solid ${props => props.theme?.menu_advanced?.border_color ?? '#fff'};
                        padding: ${props => props.theme?.menu_advanced?.padding ?? '3rem'};
                        cursor: auto;
                        > h3 {
                            font-size: ${props => props.theme?.menu_advanced?.title?.font_size ?? '2.2rem'};
                            font-family: ${props => props.theme?.menu_shortcut?.font_family ?? 'Poppins'}, sans-serif;
                            font-weight: ${props => props.theme?.menu_advanced?.title?.font_weight ?? '400'};
                            letter-spacing: 0.6px;
                            text-transform: ${props => props.theme?.menu_advanced?.title?.text_transform ?? 'uppercase'};
                            color: ${props => props.theme?.menu_advanced?.title?.color ?? '#2b2b2d'};

                            > i {
                                color: ${props => props.theme?.menu_advanced?.small_icon_color ?? '#2b2b2d'};
                                font-size: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
                            }

                            > img {
                                max-width: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
                                max-height: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
                                object-fit: contain;
                                display: inline;
                            }
                        }
                        > ul {
                            /* display: flex;
                            flex-wrap: wrap; */
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 1rem;
                            > li {
                                padding: 3.5px 0;
                                /* min-width: 120px;
                                max-width: 150px; */
                                > a {
                                    width: 100%;
                                    display: inline-block;
                                    cursor: pointer;
                                    color: ${props => props.theme?.menu_advanced?.cat_nivel_um?.color ?? '#484848'};
                                    text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_um?.text_transform ?? 'uppercase'};
                                    font-size: ${props => props.theme?.menu_advanced?.cat_nivel_um?.font_size ?? '1.2rem'};
                                    font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_um?.font_weight ?? '800'};
                                    letter-spacing: 0.2px;
                                    font-family: ${props => props.theme?.menu_shortcut?.font_family ?? props.theme?.font_family}, sans-serif;
                                    &:hover {
                                        color: ${props => props.theme?.menu_advanced?.cat_nivel_um?.color_hover ?? '#000'};
                                        text-decoration: none;
                                    }
                                    &::first-letter {
                                        text-transform: uppercase;
                                    }
                                }
                                > div {
                                    margin-bottom: 10px;
                                    > ul {
                                        > li {
                                            padding: 3.5px 0;
                                            min-width: 120px;
                                            max-width: 150px;
                                            > a {
                                                width: 100%;
                                                display: inline-block;
                                                cursor: pointer;
                                                color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color ?? '#484848'};
                                                text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.text_transform ?? 'capitalize'};
                                                font-size: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_size ?? '1.2rem'};
                                                font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_weight ?? '600'};
                                                letter-spacing: 0.2px;
                                                font-family: ${props => props.theme?.menu_shortcut?.font_family ?? props.theme?.font_family}, sans-serif;
                                                &:hover {
                                                    color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color_hover ?? '#000'};
                                                    text-decoration: none;
                                                }
                                                &::first-letter {
                                                    text-transform: uppercase;
                                                }
                                            }
                                            > div {
                                                margin-top: 2.5px;
                                                > ul {
                                                    > li {
                                                        padding: 3.5px 0;
                                                        min-width: 120px;
                                                        max-width: 150px;
                                                        > a {
                                                            width: 100%;
                                                            display: inline-block;
                                                            cursor: pointer;
                                                            letter-spacing: 0.2px;
                                                            color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color ?? '#484848'};
                                                            text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.text_transform ?? 'capitalize'};
                                                            font-size: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_size ?? '1.2rem'};
                                                            font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_weight ?? '600'};
                                                            font-family: ${props => props.theme?.menu_shortcut?.font_family ?? props.theme?.font_family}, sans-serif;
                                                            &:hover {
                                                                color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color_hover ?? '#000'};
                                                                text-decoration: none;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        > div {
                            > i {
                                color: ${props => props.theme?.menu_advanced?.big_icon_color ?? '#000'};
                                font-size: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
                            }
                            > img {
                                max-width: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
                                max-height: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
                                object-fit: contain;
                            }
                        }
                    }
                    &:hover > .menu-shortcut-advanced  {
                        display:block;
                        position: absolute;
                        ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'right: 100%;' : 'left: 100%;'}
                    }
                }
            }
        }
        &:hover {
            > a {
                color: ${props => props.theme?.menu_shortcut?.title?.color_hover ?? '#000'};
                > span::after {
                    color: ${props => props.theme?.menu_shortcut?.title?.color_hover ?? '#000'};
                }
            }
            > div {
                display:block;
                margin-top: 0px;
                position: absolute;
                ${props => props.theme?.menu_shortcut?.open_side_categories == 'left' ? 'right: 0;' : 'left: 0;'}
            }
        }
    }

    @media (max-width: 969px) {
        display: none;
    }
`;

export const CHeader = styled.div`
    border-top: 0.3rem solid ${props => props.theme?.header?.border_color ?? '#fff'};
    background-color: ${props => props.theme?.header?.background_color ?? '#fff'};
    box-shadow: 0px 0px ${props => props.theme?.header?.box_shadow?.blur ?? '0px'} ${props => props.theme?.header?.box_shadow?.color ?? '#dfdfdf'};
    border-bottom: ${props => props.theme?.header?.border_bottom?.width ?? '0px'} solid ${props => props.theme?.header?.border_bottom?.color ?? '#dfdfdf'};

    &.header-transparent {
        border-top: 0.3rem solid transparent;
        background-color: transparent;
        box-shadow: none;
        border-bottom: none;
        position: absolute;
        z-index: 999;
        left: 0;
        right: 0;

        .header-top {
            background-color: transparent;
            border-bottom: 2px solid transparent;
            color: ${props => props.theme?.header?.header_above_banner?.header_top?.color ?? props.theme?.header_top?.color ?? '#000'};
            .search-mobile-header-top {
                > i {
                    color: ${props => props.theme?.header?.header_above_banner?.search_icon_color ?? props.theme.primary_color};
                }
            }
            .cart-dropdown {
                > a {
                    span {
                        top: -.3rem;
                    }
                }
            }
            .dropdown-search.active {
                position: fixed;
                #form_search_term {
                    background-color: #fff;
                    border-color: ${props => props.theme?.header?.search?.div?.border_color ?? props.theme.primary_color};
                    > input {
                        background-color: ${props => props.theme?.header?.search?.input?.background_color ?? '#fff'};
                        color: ${props => props.theme?.header?.search?.input?.color ?? '#8d8d8d'};
                        &::placeholder {
                            color: ${props =>props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
                        }
                    }
                    > button {
                        background-color: ${props => props.theme?.header?.search?.button?.background_color ?? '#fff'};
                        &:hover {
                            background: ${props => props.theme?.header?.search?.button?.hover_background_color ?? '#f3f0f0'};
                        }
                        > i {
                            color: ${props => props.theme?.header?.search?.button?.icon_color ?? '#3398DB'};
                        }
                    }
                }
            }
        }
        #menu-center {
            background-color: transparent;
        }
        a.wishlist-link-menu i {
            color: ${props => props.theme?.header?.header_above_banner?.wishlist_icon_color ?? props.theme.primary_color};
        }
        .my-account-dropdown {
            > a {
                > span {
                    margin-left: 0;
                    color:${props => props.theme?.header?.header_above_banner?.user_icon_color ?? props.theme?.user_icon_color ?? props.theme.primary_color};
                }
                /* &:before { */
                i {
                    color: ${props => props.theme?.header?.header_above_banner?.user_icon_color ?? props.theme?.user_icon_color ?? props.theme.primary_color};
                }
            }
        }
        .cart-dropdown {
            > a {
                /* &:before, */
                &:after,
                i {
                    margin: 0;
                    color: ${props => props.theme?.header?.header_above_banner?.cart_icon_color ?? props.theme?.cart_icon_color ?? '#393f4f'} ;
                }
                span {
                    top: -.5rem;
                }
            }
        }
        .socials-header-top {
            > li {
                background-color: transparent;
                > a {
                    background-color: transparent;
                    > i::before {
                        color:${props => props.theme?.header?.header_above_banner?.header_top?.icons_color ?? props.theme?.header_top?.icons?.color ?? '#fff'};
                    }
                }
            }
        }
        ul.page-shortcut {
            > li {
                &:after {
                    color: ${props => props.theme?.header?.header_above_banner?.page_shortcut?.content_separator_color ?? props.theme?.page_shortcut?.content_separator?.color ?? '#fff'};
                }
                > a {
                    color: ${props => props.theme?.header?.header_above_banner?.page_shortcut?.color ?? props.theme?.page_shortcut?.color ?? '#000'};
                    > span {
                        &:after {
                            color: ${props => props.theme?.header?.header_above_banner?.page_shortcut?.color ?? props.theme?.page_shortcut?.color ?? '#000'};
                        }
                    }
                    &:hover,
                    &:focus {
                        > span::after {
                            color: ${props => props.theme?.header?.header_above_banner?.page_shortcut?.color_hover ?? props.theme?.page_shortcut?.color_hover ?? '#000'};
                        }
                        color: ${props => props.theme?.header?.header_above_banner?.page_shortcut?.color_hover ?? props.theme?.page_shortcut?.color_hover ?? '#000'};
                    }
                }
            }
        }
        .menu-shortcut {
            > li {
                &.pages-menu {
                    a {
                        .label-page {
                            color: ${props => props.theme?.header?.header_above_banner?.menu_shortcut?.label_page_color ?? props.theme?.menu_shortcut?.label_page?.color ?? '#777777'};
                        }
                    }
                }
                > a {
                    color: ${props => props.theme?.header?.header_above_banner?.menu_shortcut?.title_color ?? props.theme?.menu_shortcut?.title?.color ?? '#484848'};
                    > span::after,
                    &:hover > span::after,
                    &:focus > span::after {
                        color: ${props => props.theme?.header?.header_above_banner?.menu_shortcut?.title_color_hover ?? props.theme?.menu_shortcut?.title?.color_hover ?? '#000'};
                    }
                }
            }
        }

        #form_search_term {
            background-color: ${props => props.theme?.header?.header_above_banner?.search?.input_transparent_background_color ? 'transparent' :  '#fff'};
            border-color: ${props => props.theme?.header?.header_above_banner?.search?.div_border_color ?? props.theme?.header?.search?.div?.border_color ?? props.theme.primary_color};
            > input {
                background-color: ${props => props.theme?.header?.header_above_banner?.search?.input_transparent_background_color ? 'transparent' : (props.theme?.header?.header_above_banner?.search?.input_background_color ?? props.theme?.header?.search?.input?.background_color ?? '#fff')};
                color: ${props => props.theme?.header?.header_above_banner?.search?.input_color ?? props.theme?.header?.search?.input?.color ?? '#8d8d8d'};
                &::placeholder {
                    color: ${props => props.theme?.header?.header_above_banner?.search?.input_placeholder_color ?? props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'} !important;
                }
            }
            > button {
                background-color: ${props => props.theme?.header?.header_above_banner?.search?.input_transparent_background_color ? 'transparent' : (props.theme?.header?.header_above_banner?.search?.button_background_color ?? props.theme?.header?.search?.button?.background_color ?? '#fff')};
                &:hover {
                    background: ${props => props.theme?.header?.header_above_banner?.search?.input_transparent_background_color ? 'transparent' : (props.theme?.header?.header_above_banner?.search?.button_hover_background_color ?? props.theme?.header?.search?.button?.hover_background_color ?? '#f3f0f0')};
                }
                > i {
                    color: ${props => props.theme?.header?.header_above_banner?.search?.button_icon_color ?? props.theme?.header?.search?.button?.icon_color ?? '#3398DB'};
                }
            }
        }
    }
`;

export const CHeaderLeft = styled.div`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    flex: 2;

    @media (max-width: 581px) {
        justify-content: flex-start; // center;
        flex: 1; //
        display: flex;
        width: 100%;
    }
`;

const propsCHeaderRight = {
    justifyContent: {
        default: 'center',
        type:String
    }
}
export const CHeaderRight = styled('div', propsCHeaderRight)`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    margin-left: auto;
    flex: 2;
    justify-content: flex-end;
    @media (max-width: 645px){
        justify-content: flex-end;
    }
    @media (max-width: 581px){
        margin-right: auto;
        flex: 1; //
    }
`;

export const CHeaderCenter = styled.div`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    margin-right: auto;
    margin-left: auto;
    justify-content:center;
    @media (max-width: 581px){
        display: flex; // block;
        flex: 1; //
        width: 100%;
        &.logo-header-middle {
            display: flex;
            flex: 2;
        }
    }
`;

export const CHeaderMiddle = styled.div`
    color: ${props => props.theme?.header?.color ?? '#000'};
    padding: ${props => props.theme?.header?.padding ?? '2rem 0'};
    background-color: ${props => props.theme?.header?.background_color ?? '#fff'};

    @media (max-width: 581px){
        padding: ${props => props.theme?.header_top?.mobile?.show_logo_on_mobile == true && props.theme?.header_top?.mobile?.show_search_on_mobile == true ? '0' : props.theme?.header?.padding ?? '2rem 0'};
    }
`;

export const CHeaderSearch = styled.div`
    position: relative;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 0;
    line-height: 1;
`;

export const CLogoMobileHeaderTop = styled.a`
    display: none;
    width: 100%;
    min-width: ${props => props.theme?.header_top?.mobile?.width_logo ?? '80px'};
    max-width: ${props => props.theme?.header_top?.mobile?.width_logo ?? '80px'};
    margin: ${props => props.theme?.header_top?.mobile?.margin_logo ?? '0.3rem 0 0.3rem 0.5rem'};
    img {
        display: block;
        max-width: 100%;
        height: 100%;
        width: 100%;
    }

    @media (max-width: 581px){
        &.logo-mobile-top {
            display: block;
        }
    }
`;

export const CLogo = styled.a`
    display: block;
    margin: ${props => props.theme?.header?.logo?.margin ?? '0px'};
    > img {
        display: block;
        max-width: ${props => props.theme?.header?.logo?.max_width ?? '100%'};
        height: 100%;
        width: 100%;
    }
    &.top {
        display: block;
    }
    &.middle {
        display: none;
    }
    @media (max-width: 581px){
        display: flex;
        justify-content: center;
        &.top {
            display: none;
        }
        &.middle {
            display: block;
        }
        &.logo-mobile-top {
            display: none;
        }
    }
`;

const propsCSearch = {
    margin: {
        default: '2rem auto 0',
        type:String
    }
}
export const WebDropSearch = styled('div', propsCSearch)`
    
    position: absolute;
    top: 100%; /* logo abaixo do input */
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #ddd;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
    padding: .8rem 1rem;
    display: none; /* escondido até ter resultados */
    div {
        padding: 8px 12px;
        cursor: pointer;
        max-width: 100%;
        overflow:   hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .emptymessage{
            width: 100%;
            text-align: center;
        }
    }
    div:hover {
        background: #f3f3f3;
    }
`
export const CSearch = styled('form', propsCSearch)`
    display: flex;
    align-items: center;
    border-width: ${props => props.theme?.header?.search?.div?.border_width ?? '1px'};
    border-style: solid;
    border-color: ${props => props.theme?.header?.search?.div?.border_color ?? props.theme.primary_color};
    border-radius: 0;
    position: relative;
    width: ${props => props.theme?.header?.search?.div?.width ?? '380px'};
    max-width: 100%;
    background-color: #fff;
    position: initial;
    margin: ${props => props.theme?.header?.search?.div?.margin ?? 0};
    border-radius: ${props => props.theme?.header?.search?.div?.border_radius ?? 'unset'};


    > input {
        height: ${props => props.theme?.header?.search?.input?.height ?? '38px'};
        margin: ${props => props.theme?.header?.search?.input?.margin ?? '0'};
        background-color: ${props => props.theme?.header?.search?.input?.background_color ?? '#fff'};
        font: 400 1.3rem ${props => props.theme?.header?.search?.font_family_search ?? props.theme?.font_family}, sans-serif;
        flex: 1 1 auto;
        width: 100%;
        padding: 15px 22px;
        border: 0;
        color: ${props => props.theme?.header?.search?.input?.color ?? '#8d8d8d'};
        line-height: 20px;
        box-shadow: none;
        border-radius: ${props => props.theme?.header?.search?.input?.border_radius ?? 'unset'};
        &:focus{
            outline: 0;
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
            opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
        }

        ::-ms-input-placeholder { /* Microsoft Edge */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
        }
    }

    > button {
        flex: 0 0 50px;
        max-width: 50px;
        min-width: 0;
        height: ${props => props.theme?.header?.search?.button?.height ?? '38px'};
        background-color: ${props => props.theme?.header?.search?.button?.background_color ?? '#fff'};
        font-weight: 400;
        font-size: 1.4rem;
        line-height: 1;
        border: 0px;
        margin: ${props => props.theme?.header?.search?.button?.margin ?? '0'};
        cursor: pointer;
        text-align: center;
        transition: background .3s;
        border-radius: ${props => props.theme?.header?.search?.button?.border_radius ?? 'unset'};
        &:hover {
            background:  ${props => props.theme?.header?.search?.button?.hover_background_color ?? '#f3f0f0'};
        }
        &:focus{
            outline: 0;
        }
    }
    > button > i {
        color: ${props => props.theme?.header?.search?.button?.icon_color ?? '#3398DB'};
    }
    &.top {
        display: flex;
    }
    &.middle {
        display: none;
    }
    @media (max-width: 581px){
        margin: ${props => props.margin};
        &.top {
            display: none;
        }
        &.middle {
            display: flex;
        }
        &.search-mobile-top {
            display: none;
        }
    }
    @media (max-width: 380px){
        width: 100%;
    }
`;
export const WebSearch = styled('div', propsCSearch)`
    display: flex;
    align-items: center;
    border-width: ${props => props.theme?.header?.search?.div?.border_width ?? '1px'};
    border-style: solid;
    border-color: ${props => props.theme?.header?.search?.div?.border_color ?? props.theme.primary_color};
    border-radius: 0;
    position: relative;
    width: ${props => props.theme?.header?.search?.div?.width ?? '380px'};
    max-width: 100%;
    background-color: #fff;
    position: initial;
    margin: ${props => props.theme?.header?.search?.div?.margin ?? 0};
    border-radius: ${props => props.theme?.header?.search?.div?.border_radius ?? 'unset'};


    > input {
        height: ${props => props.theme?.header?.search?.input?.height ?? '38px'};
        margin: ${props => props.theme?.header?.search?.input?.margin ?? '0'};
        background-color: ${props => props.theme?.header?.search?.input?.background_color ?? '#fff'};
        font: 400 1.3rem ${props => props.theme?.header?.search?.font_family_search ?? props.theme?.font_family}, sans-serif;
        flex: 1 1 auto;
        width: 100%;
        padding: 15px 22px;
        border: 0;
        color: ${props => props.theme?.header?.search?.input?.color ?? '#8d8d8d'};
        line-height: 20px;
        box-shadow: none;
        border-radius: ${props => props.theme?.header?.search?.input?.border_radius ?? 'unset'};
        &:focus{
            outline: 0;
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
            opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
        }

        ::-ms-input-placeholder { /* Microsoft Edge */
            color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
        }
    }

    > button {
        flex: 0 0 50px;
        max-width: 50px;
        min-width: 0;
        height: ${props => props.theme?.header?.search?.button?.height ?? '38px'};
        background-color: ${props => props.theme?.header?.search?.button?.background_color ?? '#fff'};
        font-weight: 400;
        font-size: 1.4rem;
        line-height: 1;
        border: 0px;
        margin: ${props => props.theme?.header?.search?.button?.margin ?? '0'};
        cursor: pointer;
        text-align: center;
        transition: background .3s;
        border-radius: ${props => props.theme?.header?.search?.button?.border_radius ?? 'unset'};
        &:hover {
            background:  ${props => props.theme?.header?.search?.button?.hover_background_color ?? '#f3f0f0'};
        }
        &:focus{
            outline: 0;
        }
    }
    > button > i {
        color: ${props => props.theme?.header?.search?.button?.icon_color ?? '#3398DB'};
    }
    &.top {
        display: flex;
    }
    &.middle {
        display: none;
    }
    @media (max-width: 581px){
        margin: ${props => props.margin};
        &.top {
            display: none;
        }
        &.middle {
            display: flex;
        }
        &.search-mobile-top {
            display: none;
        }
    }
    @media (max-width: 380px){
        width: 100%;
    }
`;
export const CHeaderMenu = styled.div`
    display: flex;
    align-items: center;
    background: ${props => props.theme?.header?.menu?.background_color ?? props.theme.primary_color};

    @media (max-width: 969px){
        display:none;
    }
`;

export const CHeaderMenuTop = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 100%;
    padding-top: .4rem;
    padding-bottom: .4rem;
    transition: all .25s;
    border: 1px solid #ccc;
    background-color: #fff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    z-index: 20;

    > ul {
        margin: 0;
        padding: 0;
        list-style: none;

        > li {
            position: relative;
            margin: 0;
        }
    }

    @media (min-width: 992px){
        position: static;
        top: auto;
        right: auto;
        left: auto;
        padding: 0;
        border: 0;
        background-color: transparent;
        box-shadow: none;
        opacity: 1;
        visibility: visible;

        > ul {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-align: center;
            align-items: center;

            > li + li {
                margin-left: 3rem;

                &:before {
                    position: absolute;
                    top: 50%;
                    left: -14px;
                    height: 11px;
                    margin-top: -5.5px;
                    border-right: 1px solid;
                    content: '';
                    opacity: .8;
                }
            }
        }
    }
`;

export const CHeaderMenuSocials = styled.div`
    position: static;
    top: auto;
    right: auto;
    left: auto;
    min-width: 100%;
    padding: 0;
    transition: all .25s;
    border: 0;
    background-color: transparent;
    box-shadow: none;
    opacity: 1;
    visibility: visible;
    z-index: 20;

    > ul {
        margin: 0;
        padding: 0;
        list-style: none;
        font-size:0;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;

        > li {
            position: relative;
            margin: 0;
            border-radius: ${props => props.theme?.header_top?.icons?.border_radius ?? '15%'};
            background-color:  ${props => props.theme?.header_top?.icons?.background_color ?? '#000'};
            > a {
                display: -ms-inline-flexbox;
                display: inline-flex;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-pack: center;
                justify-content: center;
                background-color: ${props => props.theme?.header_top?.icons?.background_color ?? '#000'};
                color: #fff;
                font-size: 1.4rem;
                text-decoration: none;
                opacity: 1;
                transition: all .3s;
                width: ${props => props.theme?.header_top?.icons?.width ?? '2.5rem'};
                height: ${props => props.theme?.header_top?.icons?.height ?? '2.5rem'};
                border-radius:${props => props.theme?.header_top?.icons?.border_radius ?? '15%'};
                > i {
                    &:before {
                        font-size:${props => props.theme?.header_top?.icons?.font_size ?? 'unset'};
                        color:${props => props.theme?.header_top?.icons?.color ?? '#fff'};
                    }
                }
            }
        }
        > li + li {
            margin-left: 1rem;
        }

    }

    @media (min-width: 992px) {
        > ul {
            > li + li {
                margin-left: 1rem;
            }
        }
    }
`;
export const CMessageHeaderTop = styled.p`
    display: none;
    position: relative;
    margin: auto 0;
    text-transform: uppercase;


    &:before {
        content: '${props => props.theme?.header_top?.content_icon ?? ''}';
        font-weight: 900;
        font-style: normal;
        font-family: 'Font Awesome 5 Free';
        font-size: 14px;
        text-decoration: inherit;
        margin-right: ${props => props.theme?.header_top?.content_icon ? '7px' : '0'};
    }

    &:after {
        font-family: inherit;
        content: '${props => props.theme?.header_top?.content ?? ''}';
    }

    @media (min-width: 776px) {
        display: flex;
        align-items: center;
    }
`;

export const CHeaderDropdown = styled.div`
    position: relative;
    text-transform: uppercase;
    margin: ${props => props.theme?.header_top?.icons?.margin ?? '0px'};

    > a {
        display: -ms-inline-flexbox;
        display: inline-flex;
        position: relative;
        -ms-flex-align: center;
        align-items: center;
        padding-right: 1.1rem;

        > img {
            display: inline-block;
            max-width: 16px;
            height: auto;
            margin-right: .6rem;
        }
        &:hover {
            text-decoration: none;
        }

        &:focus {
            text-decoration: none;
        }

        &:after {
            position: absolute;
            top: 50%;
            right: 0;
            width: 0;
            height: 0;
            margin-top: -2px;
            margin-left: .6rem;
            border-width: 4px 3px 0;
            border-style: solid;
            border-color: #999 transparent transparent;
            content: '';
        }
    }
`;

export const CHeaderButton = styled.ul`
    font-size: 35px;
    margin: ${props => props.theme?.icon_cart_and_user_margin ?? '0'};
    display: flex;
    justify-content: space-between;
    align-items:center;
    color: #C9C9C9;
    >li {
        padding: ${props => props.theme?.icon_cart_and_user_padding ?? '0 0 0 8px'};
        > a  >i {
            color: ${props => props.theme.primary_color};
            &:hover{
                opacity: 0.7;
            }
        }
    }
    > li >  iconmenu > a {
        border-radius: 20%;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 3.2rem;
        height: 3.2rem;
        background-color: ${props => props.theme.primary_color};
        color: #fff !important;
        font-size: 2rem;
        margin-left: .5rem;
        text-decoration: none;
        opacity: 1;
        cursor:pointer;
        &:hover {
            color:${props => props.theme.primary_color} !important;
            background-color: #ece8e8;
        }
    }
    >li  {
        &:hover >div  ${CNavbarDrop} {
            display:block;
            margin-top: 5px;
            position: absolute;
            &:before {
                border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
                border-style: solid;
                border-width: 0 5px 5px 5px;
                content: '';
                height: 0;
                left: 6px;
                position: absolute;
                top: -5px;
                width: 0;
            }
        }
    }
    @media (max-width: 581px){
        display:none;
    }
    @media (max-width: 775px){
        display:none;
        .register-link {
            visibility: hidden;
            display: none;
        }
    }

`;

export const CHeaderButtonTop = styled.ul`
    font-size: 35px;
    margin:0;
    display: flex;
    justify-content: space-between;
    align-items:center;
    color: #C9C9C9;
    >li {
        > a  >i {
            color: ${props => props.theme.primary_color};
            &:hover{
                opacity: 0.7;
            }
        }
    }
    > li >  iconmenu > a {
        border-radius: 20%;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 3.2rem;
        height: 3.2rem;
        background-color: ${props => props.theme.primary_color};
        color: #fff !important;
        font-size: 2rem;
        margin-left: .5rem;
        text-decoration: none;
        opacity: 1;
        cursor:pointer;
        &:hover {
            color:${props => props.theme.primary_color} !important;
            background-color: #ece8e8;
        }
    }
    >li  {
        &:hover >div  ${CNavbarDrop} {
            display:block;
            margin-top: 5px;
            position: absolute;
            &:before {
                border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
                border-style: solid;
                border-width: 0 5px 5px 5px;
                content: '';
                height: 0;
                left: 6px;
                position: absolute;
                top: -5px;
                width: 0;
            }
        }
    }
    @media (max-width: 581px){
        display:block;
    }
    @media (max-width: 780px){
        .register-link {
            visibility: hidden;
        }
    }
`;

export const CNav = styled.ul`
    height: ${props => props.theme?.header?.menu?.height ?? '40px'};
    display:flex;
    margin:0;

    font-weight:700;
    font-family: ${props => props.theme?.header?.menu?.font_family ?? props.theme?.font_family}, sans-serif; // Poppins
    text-transform:uppercase;
    overflow:hidden;
    flex-wrap:wrap;

    background: ${props => props.theme?.header?.menu?.background_color ?? props.theme.primary_color};

    justify-content: ${props => props.theme?.header?.menu?.justify_content ?? 'start'};

    @media (max-width: 1100px) {
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
    }

    @media (max-width: 969px){
        display:none;
    }
`;

export const CNavbarItem = styled.li`
    height: 100%;
    display:flex;
    align-items:center;
    max-width: ${props => props.theme?.header?.menu?.maxwidth_category_menu ?? '400px'};
    cursor: pointer;
    ${props => props.theme?.header?.menu?.separation_line?.active ? 'border-left: 1px solid ' + props.theme?.header?.menu?.separation_line?.border_color ?? '#ffffff' : ''}

    &:first-child {
        border: none;
    }

    &.pages-menu a i {
        margin-right: 0.2rem;
    }

    &.home-item-menu {
        > a {
            display:flex;
            align-items:center;
            &:before {
                transition: background-color .3s, color .3s;
                margin-right: 5px;
                font-family: 'Font Awesome 5 Free';
                font-size: ${props => props.theme?.header?.menu?.font_size ?? '14px'};
                font-weight: 700;
                color: ${props => props.theme?.header?.menu?.color ?? '#fff'};
                content: '\\f015'

            }
        }

    }
    &.nav-item-categories {
        transition: background-color .3s, color .3s;
        background-color: ${props => props.theme?.header?.menu?.categories?.background_color ?? 'transparent'};
        border-radius: ${props => props.theme?.header?.menu?.categories?.border_radius ?? '0'};
        > a {
            transition: background-color .3s, color .3s;
            color: ${props => props.theme?.header?.menu?.categories?.color ?? props.theme?.header?.menu?.color ?? '#fff'};
            > strong, > strong > span::after {
                transition: background-color .3s, color .3s;
                color: ${props => props.theme?.header?.menu?.categories?.color ?? props.theme?.header?.menu?.color ?? '#fff'};
            }
            > i {
                transition: background-color .3s, color .3s;
                color: ${props => props.theme?.header?.menu?.categories?.color ?? props.theme?.header?.menu?.color ?? '#fff'};
                margin-right: 5px;
            }
        }
        &:hover {
            background-color: ${props => props.theme?.header?.menu?.categories?.background_color_hover ?? props.theme?.header?.menu?.categories?.background_color ?? 'transparent'};
            > a,
            > a > i,
            > a > strong,
            > a > strong > span::after {
                color: ${props => props.theme?.header?.menu?.categories?.color_hover ?? props.theme?.header?.menu?.categories?.color ?? props.theme?.header?.menu?.color_hover ?? props.theme?.header?.menu?.color ?? '#fff'};
            }
        }
    }
    > a {
        padding: ${props => props.theme?.header?.menu?.padding_menu_item ?? '0px 25px 0px 0px'};
        color: ${props => props.theme?.header?.menu?.color ?? '#fff'};
        text-decoration:none;
        transition: background-color .3s, color .3s;
        overflow: hidden;
        /* font-weight: ${props => props.theme?.header?.menu?.font_weight ?? 700};
        text-transform: ${props => props.theme?.header?.menu?.text_transform ?? 'capitalize'};
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'}; */

        display: flex;
        align-items: center;
        flex-direction: ${props => props.theme?.header?.menu?.flex_direction ?? 'row'};
        gap: 0.5rem;

        > img {
            max-width: ${props => props.theme?.header?.menu?.icons?.font_size ?? props.theme?.header?.menu?.font_size ?? '12px'};
            max-height: ${props => props.theme?.header?.menu?.icons?.font_size ?? props.theme?.header?.menu?.font_size ?? '12px'};
            object-fit: contain;
        }

        > i {
            font-size: ${props => props.theme?.header?.menu?.icons?.font_size ?? props.theme?.header?.menu?.font_size ?? '12px'};
        }

        &:hover, &:focus{
            opacity: 1;

        }
        > strong {
            font-weight: ${props => props.theme?.header?.menu?.font_weight ?? 700};
            text-transform: ${props => props.theme?.header?.menu?.text_transform ?? 'capitalize'};
            font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
            color: ${props => props.theme?.header?.menu?.color ?? '#fff'};
            transition: background-color .3s, color .3s;

            > span {
                &:after {
                    font-family: 'Porto';
                    transition: background-color .3s, color .3s;
                    font-size: 8px;
                    color: ${props => props.theme?.header?.menu?.color ?? '#fff'};
                    content: '\\e82a'
                }
            }
        }

        @media (max-width: 1100px) {
            > a {
                font-size: 10px;
            }
        }

    }
    &.home-item-menu:hover {
        a::before {
            color: ${props => props.theme?.header?.menu?.color_hover ?? props.theme?.header?.menu?.color ?? '#fff'};
        }
    }
    &:hover {
        > a,
        > a > strong,
        > a > strong > span::after {
            color: ${props => props.theme?.header?.menu?.color_hover ?? props.theme?.header?.menu?.color ?? '#fff'};
        }
        > div ${CNavbarDrop}{
            display:block;
            position: absolute;
            &:before {
                border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
                border-style: solid;
                border-width: 0 5px 5px 5px;
                content: '';
                height: 0;
                left: 25px;
                position: absolute;
                bottom: calc(-${props => props.theme?.header?.menu?.height ?? 50 } / 2);
                width: 0;
            }
        }
    }
`;

const propsCContentMenuWishlist = {
    display: {
        default: 'block',
        type: String
    },
    displayMedia: {
        default: 'none',
        type: String
    }
}

export const CHeaderTopGroupOptions = styled.ul`
    @media (max-width: 775px) {
        display: flex;
        align-items: center;
        margin: 0;
        > li + li {
            padding: ${props => props.theme?.header_top?.mobile?.padding_icons ?? '0 0 0 1rem'};
        }
    }
`

export const CSearchMobileHeaderTop = styled.div`
    display: none;
    color: ${props => props.theme?.header_top?.color ?? '#000'};
    > i {
        font-size: ${props => props.theme?.header_top?.mobile?.search_icon_font_size ?? '2.1rem'};
        margin-right: 0;
        cursor: pointer;
        &:hover {
            opacity: 1 !important;
        }
    }
    &:hover, &:focus{
        color: ${props => props.theme?.header_top?.color ?? '#000'};
    }

    .dropdown-search {
        background: rgba(0, 0, 0, 0.04);
        position: absolute;
        overflow: hidden;
        display: none;
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
        padding-inline: 2rem;
        padding-top: ${props => props.theme?.header_top?.mobile?.padding_top_search ?? '5rem'};
        z-index: 9999;

        .content-dropdown-search {
            position: relative;
            border: 4px solid #fff;
            box-shadow: 0 7px 8px rgba(0, 0, 0, 0.08);
            border-radius: ${props => props.theme?.header?.search?.div?.border_radius ?? 'unset'};

            form {
                display: flex;
                align-items: center;
                border-width: ${props => props.theme?.header?.search?.div?.border_width ?? '1px'};
                border-style: solid;
                border-color: ${props => props.theme?.header?.search?.div?.border_color ?? props.theme.primary_color};
                width: 100%;
                max-width: ${props => props.theme?.header?.search?.div?.width ?? '380px'};
                background-color: #fff;
                margin: ${props => props.theme?.header?.search?.div?.margin ?? 0};
                border-radius: ${props => props.theme?.header?.search?.div?.border_radius ?? 'unset'};


                > input {
                    height: ${props => props.theme?.header?.search?.input?.height ?? '38px'};
                    margin: ${props => props.theme?.header?.search?.input?.margin ?? '0'};
                    background-color: ${props => props.theme?.header?.search?.input?.background_color ?? '#fff'};
                    font: 400 1.3rem ${props => props.theme?.header?.search?.font_family_search ?? props.theme?.font_family}, sans-serif;
                    flex: 1 1 auto;
                    width: 100%;
                    padding: 15px 22px;
                    border: 0;
                    color: ${props => props.theme?.header?.search?.input?.color ?? '#8d8d8d'};
                    line-height: 20px;
                    box-shadow: none;
                    border-radius: ${props => props.theme?.header?.search?.input?.border_radius ?? 'unset'};
                    &:focus{
                        outline: 0;
                    }
                    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                        color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
                        opacity: 1; /* Firefox */
                    }

                    :-ms-input-placeholder { /* Internet Explorer 10-11 */
                        color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
                    }

                    ::-ms-input-placeholder { /* Microsoft Edge */
                        color: ${props => props.theme?.header?.search?.input?.placeholder_color ?? '#8d8d8d'};
                    }
                }

                > button {
                    flex: 0 0 50px;
                    max-width: 50px;
                    min-width: 0;
                    height: ${props => props.theme?.header?.search?.button?.height ?? '38px'};
                    background-color: ${props => props.theme?.header?.search?.button?.background_color ?? '#fff'};
                    font-weight: 400;
                    font-size: 1.4rem;
                    line-height: 1;
                    border: 0px;
                    margin: ${props => props.theme?.header?.search?.button?.margin ?? '0'};
                    cursor: pointer;
                    text-align: center;
                    transition: background .5s;
                    border-radius: ${props => props.theme?.header?.search?.button?.border_radius ?? 'unset'};
                    &:hover {
                        background:  ${props => props.theme?.header?.search?.button?.hover_background_color ?? '#f3f0f0'};
                    }
                    &:focus{
                        outline: 0;
                    }
                }
                > button > i {
                    color: ${props => props.theme?.header?.search?.button?.icon_color ?? '#3398DB'};
                }
            }
        }

        &.active {
            display: flex;
            justify-content: end;
            align-items: flex-start;
        }
    }

    @media (max-width: 581px) {
        display: block;
    }
`

export const CContentMenuWishlist = styled('a', propsCContentMenuWishlist)`
    &.wishlist-link-menu {
        display: ${props => props.display};
        position: relative;
        text-decoration: none;
        color: ${props => props.theme?.wishlist_icon_color ?? props.theme.primary_color};
        i {
            font-size: ${props => props.theme?.wishlist_icon_font_size ?? '2.8rem'};
            margin-right: 0.3rem;//0.5rem
            display: block;
            color: ${props => props.theme?.wishlist_icon_color ?? props.theme.primary_color};
            &:hover {
                opacity: 1 !important;
            }
        }

        .wishlist-count {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 1.6rem;
            height: 1.6rem;
            position: absolute;
            right: 0;
            line-height: 1;
            top: -.8rem;//-.2rem
            border-radius: 50%;
            padding-bottom: 1px;
            font-size: 1rem;
            font-weight: 600;
            color: #fff;
            background-color: #fa4a4a;
            box-shadow: 0 7px 8px rgba(0,0,0,0.05);
        }

        &:hover, &:focus {
            color: ${props => props.theme?.wishlist_icon_color ?? props.theme.primary_color};
        }

    }

    @media (max-width: 775px) {
        &.wishlist-link-menu {
            display: ${props => props.displayMedia};
            color: ${props => props.theme?.header_top?.color ?? '#000'};
            i {
                font-size: ${props => props.theme?.header_top?.mobile?.wishlist_icon_font_size ?? '2.1rem'};
                margin-right: 0;
                color: ${props => props.theme?.header_top?.color ?? '#000'};
                &:hover {
                    opacity: 1 !important;
                }
            }
            &:hover, &:focus{
                color: ${props => props.theme?.header_top?.color ?? '#000'};
            }
            .wishlist-count {
                right: -0.9rem;
                top: -.4rem;
            }
        }
    }
`

const propsCContentLoginAccount = {
    display: {
        default: 'block',
        type: String
    },
    displayMedia: {
        default: 'none',
        type:String
    }
}

export const CContentLoginAccount = styled('nav', propsCContentLoginAccount)`
    position: relative;

    > a {
        /* display: block; */
        display: ${props => props.display};
        position: relative;
        text-decoration: none;
        font-size: 10px;
        width: ${props => props.theme?.show_minha_conta == true ? '125px' : 'auto'};
        overflow: hidden;
        > span {
            color:${props => props.theme?.user_icon_color ?? props.theme.primary_color};
            &:hover {
                text-decoration: none;
            }
        }
        > i {
            font-size: ${props => props.theme?.user_icon_font_size ?? '3.3rem'};
            color:${props => props.theme?.user_icon_color ?? props.theme.primary_color};
            &:before {
                margin-left: 0;
                margin-right: 0;
            }
        }
        &:hover {
                text-decoration: none;
            }
        /* &:before {
            display: inline-block;
            content: '\\e82d';
            font-family: 'porto';
            font-size: 3.3rem;
            line-height: 1;
            margin: 0 0 0;
            color: ${props => props.theme?.user_icon_color ?? props.theme.primary_color};
        } */
        @media (max-width: 775px) {
            display: ${props => props.displayMedia};
            width: auto;
            /* &:before, */
            i {
                font-size: ${props => props.theme?.header_top?.mobile?.user_icon_font_size ?? '2.4rem'};
                padding: 0.5rem 0;
                color: ${props => props.theme?.header_top?.color ?? '#000'};
            }
        }
    }

    &:hover > div ${CNavbarLoginDrop} {
        display: block;
        ${props => props.sideLeft == true ? 'left: 0;' : 'right: 0;'}
        /* &:before {
            border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
            border-style: solid;
            border-width: 0 5px 5px 5px;
            content: '';
            height: 0;
            left: 138px;
            position: absolute;
            top: 20px;
            width: 0;
            right: 103px;
        } */
    }
`

export const CNavbarDrop = styled.div`
    display: none;
    position: absolute;
    max-width: 220px;
    width: 80%;
    z-index: 99;
    transition: all .25s;
    background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
`;

const propsCNavbarLoginDrop = {
    sideLeft: {
        default: false,
        type: Boolean
    }
}

export const CNavbarLoginDrop = styled('div', propsCNavbarLoginDrop)`//CNavbarDrop.extend
    display: none;
    position: absolute;
    max-width: 220px;
    width: 80%;
    z-index: 99;
    transition: all .25s;
    background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
    width: 220px;
    ${props => props.sideLeft == true ? 'left: 0;' : 'right: 0;'}
    top: 100%;// 8px;
`;

const propsCNavBrand = {
    top: {
        default: '',
        type:String
    }
}

export const CNavBrand = styled('ul', propsCNavBrand)`
    display: flex;
    background: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
    border: 1px solid ${props => props.theme?.header?.menu?.submenu?.border_color ?? 'transparent'};
    flex-direction: column;
    list-style: none;
    width: 100%;
    height: auto;
    position: absolute;
    top: ${props => props.top !== '' ? props.top : `calc(${props.theme?.header?.menu?.height ?? 50 } / 2)`};
    margin-top: 0;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
`;

export const CNavbarLinkCategoryAdvanced = styled.li`
    background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
    margin: 3px 3px 0 3px;
    cursor: pointer;
    transition: all .3s linear;
    position: relative;
    border-radius: ${props => props.theme?.header?.menu?.submenu?.border_radius_item_advanced ?? '0'};
    > a {
        width: 100%;
        height: 100%;
        padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '0.7rem 1.2rem'};
        position: relative;
        display: inline-block;
        letter-spacing: 0.2px;
        text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'uppercase'};
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '1.2rem'};
        font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? '400'};
        font-family: ${props => props.theme?.header?.menu?.font_family ?? 'Poppins'};
        color: ${props => props.theme?.header?.menu?.submenu?.color ?? '#484848'};
        &::first-letter {
            text-transform: uppercase;
        }
        > span {
            width: 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            right: 1.2rem;
            &:after {
                position: absolute;
                top: 50%;
                right: 0%;
                display: inline-block;
                transform: translateY(-50%) rotate(-90deg);
                line-height: 1;
                font-family: 'Porto';
                font-size: 8px;
                color: ${props => props.theme?.header?.menu?.submenu?.color ?? '#484848'};
                content: '\\e82a';
            }
        }
        &:hover,
        &:focus {
            > span::after {
                color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#484848'};
            }
            text-decoration: none;
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#484848'};
        }
    }
    &:last-child {
        margin-bottom: 3px;
    }
    &:hover {
        background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? '#f4f4f4'};
        > a {
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#484848'};
            > span::after {
                color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#484848'};
            }
        }
    }
    &:hover > div ${CNavbarCategoryAdvanced} {
        display: block;
        position: absolute;
    }
`;

export const CNavbarCategoryAdvanced = styled.div`
    display: none;
    position: absolute;
    width: ${props => props.theme?.menu_advanced?.width ?? '600px'};
    z-index: 99;
    transition: all .25s;
    top: -3px;
    left: 100%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
    background: ${props => props.theme?.menu_advanced?.background_color ?? '#fff'};
    border: 1px solid ${props => props.theme?.menu_advanced?.border_color ?? '#fff'};
    padding: ${props => props.theme?.menu_advanced?.padding ?? '3rem'};
    cursor: auto;
    > h3 {
        font-size: ${props => props.theme?.menu_advanced?.title?.font_size ?? '2.2rem'};
        color: ${props => props.theme?.menu_advanced?.title?.color ?? '#2b2b2d'};
        font-family: 'Poppins', sans-serif;
        font-weight: ${props => props.theme?.menu_advanced?.title?.font_weight ?? '400'};
        letter-spacing: 0.6px;
        text-transform: ${props => props.theme?.menu_advanced?.title?.text_transform ?? 'uppercase'};
        > i {
            font-size: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
            color: ${props => props.theme?.menu_advanced?.small_icon_color ?? '#2b2b2d'};
        }
        > img {
            max-width: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
            max-height: ${props => props.theme?.menu_advanced?.small_icon_size ?? '2.2rem'};
            object-fit: contain;
            display: inline;
        }
    }
    > ul {
        /* display: flex;
        flex-wrap: wrap; */
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        > li {
            padding: 3.5px 0;
            /* min-width: 120px;
            max-width: 150px; */
            > a {
                width: 100%;
                display: inline-block;
                cursor: pointer;
                color: ${props => props.theme?.menu_advanced?.cat_nivel_um?.color ?? '#484848'};
                text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_um?.text_transform ?? 'capitalize'};
                font-size: ${props => props.theme?.menu_advanced?.cat_nivel_um?.font_size ?? '1.2rem'};
                font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_um?.font_weight ?? '800'};
                letter-spacing: 0.2px;
                font-family: ${props => props.theme?.header?.menu?.font_family ?? props.theme?.font_family}, sans-serif;
                &:hover {
                    color: ${props => props.theme?.menu_advanced?.cat_nivel_um?.color_hover ?? '#000'};
                    text-decoration: none;
                }
                &::first-letter {
                    text-transform: uppercase;
                }
            }
            > div {
                margin-bottom: 10px;
                > ul {
                    > li {
                        padding: 3.5px 0;
                        min-width: 120px;
                        max-width: 150px;
                        > a {
                            width: 100%;
                            display: inline-block;
                            cursor: pointer;
                            color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color ?? '#484848'};
                            text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.text_transform ?? 'capitalize'};
                            font-size: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_size ?? '1.2rem'};
                            font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_weight ?? '600'};
                            letter-spacing: 0.2px;
                            font-family: ${props => props.theme?.header?.menu?.font_family ?? props.theme?.font_family}, sans-serif;
                            &:hover {
                                color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color_hover ?? '#000'};
                                text-decoration: none;
                            }
                            &::first-letter {
                                text-transform: uppercase;
                            }
                        }
                        > div {
                            margin-top: 2.5px;
                            > ul {
                                > li {
                                    padding: 3.5px 0;
                                    min-width: 120px;
                                    max-width: 150px;
                                    > a {
                                        width: 100%;
                                        display: inline-block;
                                        cursor: pointer;
                                        letter-spacing: 0.2px;
                                        color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color ?? '#484848'};
                                        text-transform: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.text_transform ?? 'capitalize'};
                                        font-size: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_size ?? '1.2rem'};
                                        font-weight: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.font_weight ?? '600'};
                                        font-family: ${props => props.theme?.header?.menu?.font_family ?? props.theme?.font_family}, sans-serif;
                                        &:hover {
                                            color: ${props => props.theme?.menu_advanced?.cat_nivel_dois_tres?.color_hover ?? '#000'};
                                            text-decoration: none;
                                        }
                                        &::first-letter {
                                            text-transform: uppercase;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    > div {
        > i {
            color: ${props => props.theme?.menu_advanced?.big_icon_color ?? '#000'};
            font-size: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
        }
        > img {
            max-width: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
            max-height: ${props => props.theme?.menu_advanced?.big_icon_size ?? '80px'};
            object-fit: contain;
        }
    }
`;

export const CNavbarLinkCategoryBasic = styled.li`
    position: relative;
    padding: 3px 3px 0px 3px;
    &:last-child {
        padding-bottom: 3px;
    }
    > a {
        display: flex;
        align-items:center;
        justify-content:space-between;
        padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
        font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
        background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
        cursor: pointer;
        color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
        text-decoration:none;
        overflow: hidden;
        text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};
        > span {
            &:before {
                font-family: 'Porto';
                font-size: 10px;
                content: '\\e828';
            }
        }
        &:hover{
            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
            opacity:0.9;
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
        }
    }
    > div {
        display: none;
        position: absolute;
        top: 0;
        width: 200px;
        left: 100%;
        z-index: 99;
        transition: all .25s;
        background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
        > ul {
            display: flex;
            background: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
            flex-direction: column;
            list-style: none;
            width: 100%;
            border: 1px solid ${props => props.theme?.header?.menu?.submenu?.border_color ?? 'transparent'};
            height: auto;
            position: absolute;
            margin-top: 0;
            box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
            > li {
                position: relative;
                padding: 3px 3px 0px 3px;
                > a {
                    display: flex;
                    align-items:center;
                    justify-content:space-between;
                    padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
                    font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
                    font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
                    background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
                    cursor: pointer;
                    color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
                    text-decoration:none;
                    overflow: hidden;
                    text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};
                    > span {
                        &:before {
                            font-family: 'Porto';
                            font-size: 10px;
                            content: '\\e828'
                        }
                    }
                    &:hover {
                        background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                        opacity:0.9;
                        color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                    }
                }
                &:last-child {
                    padding-bottom: 3px;
                }
                > div {
                    display: none;
                    position: absolute;
                    top: 0;
                    width: 200px;
                    left: 100%;
                    z-index: 99;
                    transition: all .25s;
                    background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                    > ul {
                        display: flex;
                        background: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                        flex-direction: column;
                        list-style: none;
                        width: 100%;
                        border: 1px solid ${props => props.theme?.header?.menu?.submenu?.border_color ?? 'transparent'};
                        height: auto;
                        position: absolute;
                        margin-top: 0;
                        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
                        > li {
                            position: relative;
                            padding: 3px 3px 0px 3px;
                            > a {
                                display: flex;
                                align-items:center;
                                justify-content:space-between;
                                padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
                                font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
                                font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
                                background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
                                cursor: pointer;
                                color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
                                text-decoration:none;
                                overflow: hidden;
                                text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};
                                > span {
                                    &:before {
                                        font-family: 'Porto';
                                        font-size: 10px;
                                        content: '\\e828'
                                    }
                                }
                                &:hover{
                                    background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                    opacity:0.9;
                                    color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                }
                            }
                            &:last-child {
                                padding-bottom: 3px;
                            }
                            > div {
                                display: none;
                                position: absolute;
                                top: 0;
                                width: 200px;
                                left: 100%;
                                z-index: 99;
                                transition: all .25s;
                                background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                                > ul {
                                    display: flex;
                                    background: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                                    flex-direction: column;
                                    list-style: none;
                                    width: 100%;
                                    border: 1px solid ${props => props.theme?.header?.menu?.submenu?.border_color ?? 'transparent'};
                                    height: auto;
                                    position: absolute;
                                    margin-top: 0;
                                    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
                                    > li {
                                        position: relative;
                                        padding: 3px 3px 0px 3px;
                                        > a {
                                            display: flex;
                                            align-items:center;
                                            justify-content:space-between;
                                            padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
                                            font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
                                            font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
                                            background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
                                            cursor: pointer;
                                            color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
                                            text-decoration:none;
                                            overflow: hidden;
                                            text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};
                                            > span {
                                                &:before {
                                                    font-family: 'Porto';
                                                    font-size: 10px;
                                                    content: '\\e828'
                                                }
                                            }
                                            &:hover{
                                                background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                                opacity:0.9;
                                                color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                            }
                                        }
                                        &:last-child {
                                            padding-bottom: 3px;
                                        }
                                        > div {
                                            display: none;
                                            position: absolute;
                                            top: 0;
                                            width: 200px;
                                            left: 100%;
                                            z-index: 99;
                                            transition: all .25s;
                                            background-color: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                                            > ul {
                                                display: flex;
                                                background: ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                                                flex-direction: column;
                                                list-style: none;
                                                width: 100%;
                                                border: 1px solid ${props => props.theme?.header?.menu?.submenu?.border_color ?? 'transparent'};
                                                height: auto;
                                                position: absolute;
                                                margin-top: 0;
                                                box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
                                                > li {
                                                    position: relative;
                                                    padding: 3px 3px 0px 3px;
                                                    > a {
                                                        display: flex;
                                                        align-items:center;
                                                        justify-content:space-between;
                                                        padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
                                                        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
                                                        font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
                                                        background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
                                                        cursor: pointer;
                                                        color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
                                                        text-decoration:none;
                                                        overflow: hidden;
                                                        text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};
                                                        > span {
                                                            &:before {
                                                                font-family: 'Porto';
                                                                font-size: 10px;
                                                                content: '\\e828'
                                                            }
                                                        }
                                                        &:hover{
                                                            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                                            opacity:0.9;
                                                            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                                        }
                                                    }
                                                    &:last-child {
                                                        padding-bottom: 3px;
                                                    }
                                                    &:hover {
                                                        > a {
                                                            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                                            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        &:hover {
                                            > a {
                                                background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                                color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                            }
                                            > div {
                                                display: block;
                                                margin-top: 0px;
                                            }
                                        }
                                    }
                                }
                            }
                            &:hover {
                                > a {
                                    background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                                    color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                                }
                                > div {
                                    display: block;
                                    margin-top: 0px;
                                }
                            }
                        }
                    }
                }
                &:hover {
                    > a {
                        background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
                        color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
                    }
                    > div {
                        display: block;
                        margin-top: 0px;
                    }
                }
            }
        }
    }
    &:hover {
        > a {
            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
        }
        > div {
            display: block;
            margin-top: 0px;
        }
    }
`;

export const CNavbarLink = styled.li`
    position: relative;
    padding: 3px 3px 0px 3px;
    > a {
        display: flex;
        align-items:center;
        justify-content:space-between;
        padding: ${props => props.theme?.header?.menu?.submenu?.padding ?? '10px'};
        font-size: ${props => props.theme?.header?.menu?.font_size ?? '12px'};
        font-weight: ${props => props.theme?.header?.menu?.submenu?.font_weight ?? 600};
        background-color: ${props => props.theme?.header?.menu?.submenu?.background_color_item_submenu ?? '#fff'};
        cursor: pointer;
        color: ${props => props.theme?.header?.menu?.submenu?.color ?? props.theme.primary_color};
        text-decoration:none;
        overflow: hidden;
        text-transform: ${props => props.theme?.header?.menu?.submenu?.text_transform ?? 'capitalize'};

        > span {
            &:before {
                font-family: 'Porto';
                font-size: 10px;
                content: '\\e828'
            }
        }
        &:hover{
            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
            opacity:0.9;
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
        }

    }
    &:last-child {
        padding-bottom: 3px;
    }

    &:hover {
        > a {
            color: ${props => props.theme?.header?.menu?.submenu?.hover_color ?? '#fff'};
            background-color: ${props => props.theme?.header?.menu?.submenu?.hover_background_color ?? props.theme.primary_color};
        }
        > div ${CNavSub} {
            display:block;
            margin-left: 3px;
            top: calc(-${props => props.theme?.header?.menu?.height ?? 50 } / 2);
            /* &:before {
                border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
                border-style: solid;
                border-top: 5px solid transparent;
                border-bottom: 5px solid transparent;
                border-right: 5px solid ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'};
                content: '';
                height: 0;
                right: 219px;
                position: absolute;
                top: calc(${props => props.theme?.header?.menu?.height ?? 50 } / 1.5);
                width: 0;
            } */
        }
    }

`;

export const CNavSub = styled.div`
  display:none;
  position: absolute;
  width: 100%;
  left: 98%;
  z-index:99;
  box-shadow: 0px 0px 30px 5px rgba(0,0,0,0.200);
`;

export const CWelcomeMsg = styled.p`
    display: none;
    position: relative;
    margin: auto 0;
    text-transform: uppercase;

    @media (min-width: 776px) {
        display: block;
    }
`;
